import { useState } from "react";
import { T } from "./todoTokens";

/* Bulk actions — reassign · reschedule · complete (user choice on §20.4). */
export const BulkBar = ({ count, reps, onClear, onAction }) => {
  const [mode, setMode] = useState(null);
  const [val, setVal] = useState("");

  const run = () => {
    if (mode === "reschedule") onAction("reschedule", { due_date: val });
    if (mode === "reassign") onAction("reassign", { owner_name: val });
    setMode(null); setVal("");
  };

  return (
    <div className="sticky bottom-4 z-[60] rounded-[10px] px-4 py-2.5 flex items-center gap-3 flex-wrap"
      style={{ background: "#FFFBEA", border: "1px solid #EFE0A0" }} data-testid="todos-bulk-bar">
      <span className="text-[12.5px] font-semibold" style={{ color: T.ink }}>
        {count} to-do{count === 1 ? "" : "s"} selected
      </span>
      <span style={{ width: 1, height: 18, background: "#EFE0A0" }} />

      {!mode && (
        <>
          <Act label="Complete" onClick={() => onAction("complete")} testid="bulk-complete" />
          <Act label="Reschedule" onClick={() => setMode("reschedule")} testid="bulk-reschedule" />
          <Act label="Reassign" onClick={() => setMode("reassign")} testid="bulk-reassign" />
        </>
      )}

      {mode === "reschedule" && (
        <>
          <input type="date" autoFocus value={val} onChange={(e) => setVal(e.target.value)}
            className="h-8 rounded-[7px] px-2 text-[12.5px]" style={{ border: `1px solid ${T.cardEdge}` }}
            data-testid="bulk-date-input" />
          <Act label="Move them" onClick={run} disabled={!val} testid="bulk-date-apply" primary />
        </>
      )}

      {mode === "reassign" && (
        <>
          <select autoFocus value={val} onChange={(e) => setVal(e.target.value)}
            className="h-8 rounded-[7px] px-2 text-[12.5px] bg-white" style={{ border: `1px solid ${T.cardEdge}` }}
            data-testid="bulk-owner-select">
            <option value="">Choose a person</option>
            {reps.map((r) => <option key={r} value={r}>{r}</option>)}
          </select>
          <Act label="Hand them over" onClick={run} disabled={!val} testid="bulk-owner-apply" primary />
        </>
      )}

      <button onClick={() => { setMode(null); setVal(""); onClear(); }}
        className="text-[12.5px] ml-auto hover:underline" style={{ color: T.ink2 }} data-testid="bulk-clear">Clear</button>
    </div>
  );
};

const Act = ({ label, onClick, disabled, primary, testid }) => (
  <button onClick={onClick} disabled={disabled} data-testid={testid}
    className="h-8 px-3 rounded-[7px] text-[12.5px] font-semibold disabled:opacity-50"
    style={primary
      ? { background: T.accent, border: `1px solid ${T.accentEdge}`, color: T.accentInk }
      : { background: "#fff", border: `1px solid ${T.cardEdge}`, color: T.ink2 }}>{label}</button>
);
